var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QSubmenu',_vm._b({class:{ 'q-sticky-submenu': _vm.sticky },style:(_vm.sticky && _vm.getStickyStyle),attrs:{"title":_vm.getTitle,"submenu":_vm.getSubmenu,"buttons":_vm.getButtons,"titlelink":_vm.titlelink}},'QSubmenu',{
        ...(!!_vm.baseUrl && { baseUrl: _vm.baseUrl }),
    },false))
}
var staticRenderFns = []

export { render, staticRenderFns }